'use strict';

(function () {
  var API_URL = 'https://api.giveaway.ninja/api/ui/calculateEntries';
  var TOKEN_KEY = 'giveawayninja_at';
  var TOKEN_MAX_WAIT = 5000;
  var TOKEN_POLL_INTERVAL = 200;
  var FETCH_TIMEOUT = 10000;
  var BATCH_DELAY = 300;

  var accessTokenPromise = null;
  var pendingCards = new Set();
  var batchTimerId = null;
  var accessToken = null;

  function getAccessToken() {
    if (accessTokenPromise) return accessTokenPromise;
    accessTokenPromise = new Promise(function (resolve) {
      var startTime = Date.now();
      function poll() {
        try {
          var token = localStorage.getItem(TOKEN_KEY);
          if (token && token !== 'null') { resolve(token); return; }
          if (Date.now() - startTime >= TOKEN_MAX_WAIT) { resolve(null); return; }
          setTimeout(poll, TOKEN_POLL_INTERVAL);
        } catch (e) { resolve(null); }
      }
      poll();
    });
    return accessTokenPromise;
  }

  function scheduleBatch() {
    clearTimeout(batchTimerId);
    batchTimerId = setTimeout(processBatch, BATCH_DELAY);
  }

  async function processBatch() {
    if (!accessToken) {
      accessToken = await getAccessToken();
      if (!accessToken) return;
    }

    var cards = Array.from(pendingCards);
    pendingCards.clear();
    if (cards.length === 0) return;

    await Promise.allSettled(cards.map(calculateForCard));
  }

  async function calculateForCard(card) {
    var giveawayId = card.dataset.giveawayId;
    var productId = card.dataset.productId;
    var variantId = card.dataset.variantId;
    var price = parseInt(card.dataset.variantPrice, 10) || 0;

    if (!giveawayId || !productId || !variantId) return;

    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT);

    try {
      // NOTE: Access token passed as query param per Giveaway Ninja API requirements.
      // Prefer Authorization header if their API adds support for it.
      var response = await fetch(
        API_URL + '?access_token=' + encodeURIComponent(accessToken),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            giveawayId: giveawayId,
            productId: String(productId),
            variantId: String(variantId),
            quantity: 1,
            price: price,
          }),
          signal: controller.signal,
        }
      );
      clearTimeout(timeoutId);

      if (!response.ok) return;
      var result = await response.json();

      if (result.status === 'Success' && result.data) {
        card.updateBadge(result.data);
      }
    } catch (error) {
      clearTimeout(timeoutId);
    }
  }

  class GiveawayCardBadge extends HTMLElement {
    connectedCallback() {
      this.badge = this.querySelector('.badge--giveaway');
      if (!this.badge) return;

      pendingCards.add(this);
      scheduleBatch();
    }

    disconnectedCallback() {
      pendingCards.delete(this);
    }

    updateBadge(data) {
      if (!this.badge) return;
      var totalEntries = data.totalEntries || 0;
      if (totalEntries <= 0 || data.isExpired) {
        this.badge.style.display = 'none';
        return;
      }
      var textEl = this.badge.querySelector('.giveaway-badge__text');
      if (textEl) {
        var label = this.badge.dataset.entriesLabel || '{entries} entries';
        textEl.textContent = label.replace('{entries}', totalEntries);
      }
      this.badge.style.display = '';
    }
  }

  if (!customElements.get('giveaway-card-badge')) {
    customElements.define('giveaway-card-badge', GiveawayCardBadge);
  }
})();
